import { render, staticRenderFns } from "./meFooter.vue?vue&type=template&id=9a7afd22&scoped=true&"
import script from "./meFooter.vue?vue&type=script&lang=js&"
export * from "./meFooter.vue?vue&type=script&lang=js&"
import style0 from "./meFooter.vue?vue&type=style&index=0&id=9a7afd22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7afd22",
  null
  
)

export default component.exports